import React from 'react';
import VirtualizedList from './VirtualizedList';
import StateSection from './StateSection';

interface SectionItem {
    key: string;
    value: any;
    isMatch: boolean;
    isExpanded: boolean;
}

interface StateContentProps {
    sectionsToRender: SectionItem[];
    debouncedSearchTerm: string;
    toggleSection: (key: string) => void;
    parseSearchPath: (search: string) => string | null;
    searchResults: Record<string, boolean>;
    matchingPaths: string[];
    setHoveredPath: (path: string) => void;
}

/**
 * Component for displaying the content of the state viewer
 * @param props - Component props
 * @returns Rendered component
 */
const StateContent: React.FC<StateContentProps> = ({
    sectionsToRender,
    debouncedSearchTerm,
    toggleSection,
    parseSearchPath,
    searchResults,
    matchingPaths,
    setHoveredPath,
}) => {
    return (
        <div className="p-2 pb-8">
            {/* Add bottom padding to ensure content doesn't get hidden behind the path bar */}
            {sectionsToRender.length > 0 ? (
                /* Render only a limited number of sections at once for better performance */
                <VirtualizedList
                    items={sectionsToRender}
                    renderItem={(
                        { key, value, isMatch, isExpanded },
                        index,
                    ) => (
                        <StateSection
                            key={key}
                            sectionKey={key}
                            sectionValue={value}
                            isExpanded={isExpanded}
                            isMatch={isMatch}
                            onToggle={toggleSection}
                            searchPath={parseSearchPath(debouncedSearchTerm)}
                            searchResults={searchResults}
                            matchingPaths={matchingPaths}
                            onHoverPath={setHoveredPath}
                        />
                    )}
                />
            ) : debouncedSearchTerm ? (
                <div className="py-4 text-center text-gray-500">
                    No matching sections found
                </div>
            ) : null}
        </div>
    );
};

export default StateContent;
